import fetch from "isomorphic-fetch";
import { message, setIsFetching } from "../../../actions";
import Configuration from "../../../config.js";
import ReactGA from "react-ga";
import { translations } from "../../../config";

/**
 * Konstanten
 */
export const SET_DOMAINS = "SET_DOMAINS";

/**
 * Setter
 */
export function setDomains( json )
{
	return {
		type: SET_DOMAINS,
		json
	};
}

/**
 * Zeigt alle Domains in der Übersicht an
 */
export function getDomains()
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Domain",
				action: "Domains laden"
			} );
		}
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		
		return fetch(
			`${Configuration.apiUrl}/domains?${+new Date()}`,
			{
				credentials: "include",
				method: "GET",
				headers
			}
		)
			.then(
				response =>
				{
					if ( response.ok )
					{
						response.json()
							.then( json =>
								{
									dispatch( setDomains( json ) );
								}
							);
					}
					else
					{
						response.json()
							.then( json =>
								{
									// Der Nutzer erfährt warum die Anfrage fehlgeschlagen ist.
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function getDomains(...)

/**
 * Api-Anfrage: Neue Domain erstellen
 *
 * @param {Object} a_formData
 */
export function createDomains( a_formData )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Domain",
				action: "Domain anlegen"
			} );
		}
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		headers[ "content-type" ] = "application/json";
		
		return fetch(
			`${Configuration.apiUrl}/domains`,
			{
				credentials: "include",
				method: "POST",
				headers,
				body: JSON.stringify( a_formData )
			}
		)
			.then(
				response =>
				{
					// Domain angelegt
					if ( response.ok )
					{
						// Angelegte ID merken
						response.json()
							.then( json =>
								{
									const user = getState().user;
									const domains = [ ...getState().domains ];
									domains.push(
										{
											article_id: json.article_id.toString(),
											domain_description: a_formData.description ? a_formData.description : null,
											domain_name: a_formData.name,
											expiring_date: null,
											id: json.id.toString(),
											organization_id: user.organization.id,
											price: a_formData.price,
											sort_id: null,
											start_date: new Date( a_formData.start_date )
										}
									);
									
									dispatch( setDomains( domains ) );
								}
							);
						
						// Der Nutzer soll ein Alert erhalten, dass die Anfrage erfolgreich war.
						dispatch( message( `${translations.de_DE.words.domain} erfolgreich angelegt.`, "info", 5000 ) );
					}
					// Eingabefehler oder Serverfehler
					else
					{
						response.json()
							.then( json =>
								{
									// Der Nutzer erfährt warum die Anfrage fehlgeschlagen ist.
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function createDomains(...)

/**
 * Api-Anfrage: Domain bearbeiten
 *
 * @param {Object} a_formData
 */
export function patchDomains( a_formData )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Domain",
				action: "Domain bearbeiten"
			} );
		}
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		headers[ "content-type" ] = "application/json";
		
		return fetch(
			`${Configuration.apiUrl}/domains/${a_formData.id}`,
			{
				credentials: "include",
				method: "PATCH",
				headers,
				body: JSON.stringify( a_formData )
			}
		)
			.then(
				response =>
				{
					// Domain aktualisiert
					if ( response.ok )
					{
						const domains = { ...getState().domains };
						const updatedDomains = Object.keys( domains ).map(
							( a_key ) =>
							{
								const domain = domains[ a_key ];
								
								if ( a_formData.id === domain.id && a_formData.article_id === domain.article_id )
								{
									if ( a_formData.start_date )
									{
										const dateArray = a_formData.start_date.split( "." );
										const date = new Date( parseInt( dateArray[ 2 ] ), parseInt( dateArray[ 1 ] ) - 1, parseInt( dateArray[ 0 ] ) );
										domain[ "start_date" ] = `${[
											date.getFullYear(),
											( "0" + ( date.getMonth() + 1 ) ).slice( -2 ),
											( "0" + ( date.getDate() ) ).slice( -2 )
										].join( "-" )}T00:00:00`;
									}
									if ( a_formData.expiring_at )
									{
										const dateArray = a_formData.expiring_at.split( "." );
										const date = new Date( parseInt( dateArray[ 2 ] ), parseInt( dateArray[ 1 ] ) - 1, parseInt( dateArray[ 0 ] ) );
										domain[ "expiring_date" ] = `${[
											date.getFullYear(),
											( "0" + ( date.getMonth() + 1 ) ).slice( -2 ),
											( "0" + ( date.getDate() ) ).slice( -2 )
										].join( "-" )}T00:00:00`;
									}
									if ( a_formData.domain_description )
									{
										domain[ "domain_description" ] = a_formData.domain_description;
									}
								}
								
								return domain;
							}
						);
						dispatch( setDomains( updatedDomains ) );
						
						// Der Nutzer soll ein Alert erhalten, dass die Anfrage erfolgreich war.
						dispatch( message( `${translations.de_DE.words.domain} erfolgreich geändert.`, "info", 5000 ) );
					}
					// Eingabefehler oder Serverfehler
					else
					{
						response.json()
							.then( json =>
								{
									// Der Nutzer erfährt warum die Anfrage fehlgeschlagen ist.
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function patchDomains(...)

/**
 * Api-Anfrage: Domain löschen
 *
 * @param {number} a_id
 */
export function deleteDomains( a_id )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Domain",
				action: "Domain löschen"
			} );
		}
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		
		return fetch(
			`${Configuration.apiUrl}/domains/${a_id}`,
			{
				credentials: "include",
				method: "DELETE",
				headers
			}
		)
			.then(
				response =>
				{
					if ( response.ok )
					{
						// TODO
						// dispatch( setDomains(  ) );
						
						// Der Nutzer soll ein Alert erhalten, dass die Anfrage erfolgreich war.
						dispatch( message( `${translations.de_DE.words.domain} erfolgreich gelöscht.`, "info", 5000 ) );
					}
					else
					{
						response.json()
							.then( json =>
								{
									// Der Nutzer erfährt warum die Anfrage fehlgeschlagen ist.
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function deleteDomains(...)